<template>
    <div class="breadcrumb-line breadcrumb-line-component">
        <a class="breadcrumb-elements-toggle"><i class="icon-menu-open"></i></a>
        <ul class="breadcrumb">
            <li><router-link :to="{name: 'dashboard'}"><i class="icon-home2 position-left"></i> Home</router-link></li>
            <li v-for="(bc, idx) in breadcrumbList" :key="idx" :class="{'linked': !!bc.link}" @click="routeTo(idx)">
                {{ bc }}
            </li>
        </ul>
        <ul class="breadcrumb-elements" slot="topRightActions"></ul>
    </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data () {
    return {
      breadcrumbList: []
    }
  },
  mounted () {
    this.updateList()
  },
  watch: {
    '$route' () {
      this.updateList()
    }
  },
  methods: {
    routeTo (pRouteTo) {
      if (this.breadcrumbList[pRouteTo].link) {
        this.$router.push(this.breadcrumbList[pRouteTo].link)
      }
    },
    updateList () {
      if (this.$route.meta) {
        if (this.$route.meta.breadcrumb) {
          let bc = this.$route.meta.breadcrumb
          if (!Array.isArray(bc)) {
            bc = [bc]
          }
          this.breadcrumbList = bc
          return
        }
      }
      this.breadcrumbList = []
    }
  }
}
</script>

<style scoped>

</style>
